import React from 'react';
import { ArrowLeft } from 'lucide-react';
import Footer from '../components/Footer';

const MentionsLegales: React.FC = () => {
  return (
    <>
    <div className="min-h-screen bg-stone-50">
      <div className="container-max section-padding py-12">
        <a 
          href="/"
          className="inline-flex items-center space-x-2 text-wood-600 hover:text-wood-700 mb-8"
        >
          <ArrowLeft className="w-4 h-4" />
          <span>Retour à l'accueil</span>
        </a>

        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 max-w-4xl">
          <h1 className="text-3xl md:text-4xl font-bold text-stone-900 mb-8">
            Mentions Légales
          </h1>

          <div className="space-y-8 text-stone-700">
            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">1. Éditeur du site</h2>
              <p className="mb-2">
                <strong>Raison sociale :</strong> ARS AGENCEMENT
              </p>
              <p className="mb-2">
                <strong>Gérant :</strong> Jérémy ARS
              </p>
              <p className="mb-2">
                <strong>Adresse :</strong> 2 Rue Joseph le Brix, 56400 Plougoumelen
              </p>
              <p className="mb-2">
                <strong>Téléphone :</strong> <a href="tel:+33676825228" className="text-wood-600 hover:text-wood-700">+33 6 76 82 52 28</a>
              </p>
              <p className="mb-2">
                <strong>Email :</strong> <a href="mailto:contact@ars-agencement.bzh" className="text-wood-600 hover:text-wood-700">contact@ars-agencement.bzh</a>
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">2. Hébergeur</h2>
              <p className="mb-2">
                <strong>Hébergeur :</strong> OVH
              </p>
              <p className="mb-2">
                <strong>Siège social :</strong> 2 rue Kellermann, 59100 Roubaix, France
              </p>
              <p className="mb-2">
                <strong>Site web :</strong> <a href="https://www.ovh.com" target="_blank" rel="noopener noreferrer" className="text-wood-600 hover:text-wood-700">www.ovh.com</a>
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">3. Conception et réalisation</h2>
              <p className="mb-2">
                <strong>Studio de création :</strong> <a href="https://izenah.bzh" target="_blank" rel="noopener noreferrer" className="text-wood-600 hover:text-wood-700 font-medium">izenah.bzh</a>
              </p>
              <p className="text-stone-600">
                Design, développement et intégration du site web
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">4. Propriété intellectuelle</h2>
              <p className="leading-relaxed">
                L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur 
                et la propriété intellectuelle. Tous les droits de reproduction sont réservés, y compris pour les 
                documents téléchargeables et les représentations iconographiques et photographiques.
              </p>
              <p className="mt-4 leading-relaxed">
                La reproduction de tout ou partie de ce site sur un support électronique ou autre quel qu'il soit 
                est formellement interdite sauf autorisation expresse du directeur de la publication.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">5. Crédits photos</h2>
              <p className="leading-relaxed">
                Les photographies présentes sur ce site sont la propriété exclusive d'ARS AGENCEMENT et ne peuvent 
                être utilisées sans autorisation préalable écrite.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">6. Limitation de responsabilité</h2>
              <p className="leading-relaxed">
                ARS AGENCEMENT s'efforce d'assurer au mieux de ses possibilités, l'exactitude et la mise à jour 
                des informations diffusées sur ce site. Toutefois, ARS AGENCEMENT ne peut garantir l'exactitude, 
                la précision ou l'exhaustivité des informations mises à disposition sur ce site.
              </p>
              <p className="mt-4 leading-relaxed">
                En conséquence, ARS AGENCEMENT décline toute responsabilité pour toute imprécision, inexactitude 
                ou omission portant sur des informations disponibles sur ce site.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-stone-900 mb-4">7. Liens hypertextes</h2>
              <p className="leading-relaxed">
                Les liens hypertextes mis en place dans le cadre du présent site internet en direction d'autres 
                ressources présentes sur le réseau Internet ne sauraient engager la responsabilité d'ARS AGENCEMENT.
              </p>
            </section>
          </div>

          <div className="mt-12 pt-8 border-t border-stone-200">
            <p className="text-sm text-stone-500">
              Date de dernière mise à jour : Juin 2026
            </p>
          </div>
        </div>
      </div>
    </div>
    <Footer />
    </>
  );
};

export default MentionsLegales;
